import { saveObject, saveObjectMetaData } from "../../components/menu/SaveLoad";

export const getMetaDataFromSave = (save: saveObject): saveObjectMetaData => {
    const {
        insta, gameObject, persistent, sounds, ...meta
    } = save;

    return meta;

};